import { styled } from 'styled-components';

export const DivFormRegister = styled.div`
    box-sizing: border-box;
    min-height: calc( 100vh - 120px );

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .area-register {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 20px;
        max-width: 500px;
        min-height: calc( 100vh - 500px );
        margin: 30px auto;
        box-sizing: border-box;
        border-radius: 20px;
        box-shadow: 1px 1px 6px #CCCCCC;
    }

    @media screen and (max-width: 525px) {
        .area-register {
            box-shadow: none;
        }
    }

`